<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div v-show="$route.path == '/Master/Plant'" class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store-alt"></i>
            </span>
            <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-8 col-lg-8 col-md-8 .col-sm-8 col-xs-8">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="keyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก รหัสคลังสินค้า, ชื่อคลังสินค้า โดยสามารถคั่นระหว่างคำได้ด้วยเครื่องหมายลูกน้ำ เช่น รหัสคลังสินค้า1, ชื่อคลังสินค้า2"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'activeStatusKey'"
                    :name="'activeStatusKey'"
                    :select2-options="activeStatusKeyOptions"
                    v-model="activeStatusKey"
                    ref="activeStatusKeySelect2"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button type="reset" class="btn btn-secondary" @click="formReset">ล้างค่าทั้งหมด</button>
              </div>
              <div class="col-xl-6 text-right"></div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="plantTable"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th class="all">รหัสคลังสินค้า</th>
                    <th class="all">ชื่อคลังสินค้า</th>
                    <th class="none">ที่อยู่</th>
                    <th class="none">อีเมล</th>
                    <th class="all">เบอร์โทร</th>
                    <th class="all">ชื่อผู้ติดต่อ</th>
                    <th class="none">Latitude</th>
                    <th class="none">Longitude</th>
                    <!-- <th class="none">รูปภาพ</th> -->
                    <th class="none">ผลิตภัณฑ์</th>
                    <th class="all">สถานะ</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
import DatatableWarning from "../../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let StatusActionsTrue = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-success">
      <i class="fas fa-play"></i>เปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#plantTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/Plant/" + this.data.plantId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let StatusActionsFalse = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="editStatus" v-if="data.showEditStatusButton" class="btn btn-sm btn-danger">
      <i class="fas fa-pause"></i>ปิดใช้งาน
    </a>
  </div>`,
  methods: {
    editStatus: function() {
      let self = this;
      var table = $("#plantTable");
      Swal.fire({
        title: "คำสั่งแก้ไขสถานะ",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งแก้ไขสถานะ <strong>" +
          "</strong> หลังจากกดแล้วจะส่งผลให้สถานะถูกเปิดใช้งาน",
        inputPlaceholder: "ต้องการแก้ไขสถานะ",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        Swal.fire("สำเร็จ", "success");
        if (result.value === true || result.value === false) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่..."
          });

          axios
            .put("/Api/Plant/" + this.data.plantId + "/Toggle")
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});
let Action = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
  </div>`,
    // <a href="#" @click.prevent="deletePlant" v-if="data.showDeleteButton" title="ลบ" class="btn btn-sm btn-clean btn-icon btn-icon-md">
    //   <i class="la la-trash"></i>
    // </a>
  methods: {
    edit: function() {
      router.push({
        path: `/Master/Plant/Edit/${this.data.plantId}`
      });
    },
    // deletePlant: function() {
    //   let self = this;
    //   Swal.fire({
    //     title: "คำสั่งลบคลังสินค้า",
    //     type: "warning",
    //     html:
    //       "กรุณายืนยันคำสั่งลบข้อมูลคลังสินค้า <strong>" +
    //       "</strong> หลังจากลบแล้วจะส่งผลให้คลังสินค้านี้ไม่ถูกใช้งาน",
    //     input: this.data.userCount > 0 ? "checkbox" : "",
    //     inputValue: 0,
    //     inputPlaceholder: "ต้องการลบข้อมูลคลังสินค้าออกจากข้อมูล",
    //     showCancelButton: true,
    //     confirmButtonText: "ยืนยัน",
    //     cancelButtonText: "ยกเลิก",
    //     showLoaderOnConfirm: true
    //   }).then(result => {
    //     if (result.value) {
    //       KTApp.blockPage({
    //         opacity: 0.05,
    //         message: "กำลังลบข้อมูล กรุณารอสักครู่..."
    //       });
    //       axios
    //         .put("/Api/Plant/" + this.data.plantId + "/Delete")
    //         .then(function(response) {
    //           if (response.data.data) {
    //             self.$parent.reloadDataTable();
    //             Swal.fire("สำเร็จ", response.data.message, "success");
    //           } else {
    //             Swal.fire(
    //               "เกิดข้อผิดพลาด",
    //               error.response.data.message,
    //               "error"
    //             );
    //           }
    //         })
    //         .catch(function(error) {
    //           Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
    //         })
    //         .then(function() {
    //           // always executed
    //           KTApp.unblockPage();
    //         });
    //     }
    //   });
    // }
  }
});

export default {
  components: {
    select2
  },
  data: function() {
    return {
      keyword: "",
      activeStatusKey: "",
      //config
      activeStatusKeyOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "false", text: "ใช้งาน", data: null },
          { id: "true", text: "ปิดใช้งาน", data: null }
        ]
      }
    };
  },
  methods: {
    formReset: function(e) {
      this.keyword = "";
        
      //default Active Data
      this.activeStatusKey = false;
      $("#activeStatusKey")
        .val(this.activeStatusKey + "")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#plantTable").DataTable();
      //table.search(this.stockID | this.stockName);
      table.column(4).search(this.status != "-1" ? this.status : "");
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#plantTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    }
  },
  async mounted() {
    let self = this;

    //default Active Data
      self.activeStatusKey = false;
      $("#activeStatusKey")
        .val(self.activeStatusKey + "")
        .trigger("change");

    $("#plantKey").select2({
      tags: true,
      placeholder: "กรุณาเลือก",
      allowClear: true,
      ajax: {
        url: "/Api/Plant/Select2SearchPlant",
        data: function(params) {
          var query = {
            search: params.term,
            page: params.page || 1
          };
          return query;
        },
        processResults: function(data, params) {
          return {
            results: data.results,
            pagination: {
              more: data.more
            }
          };
        },
        transport: function(params, success, failure) {
          params.beforeSend = function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          };
          var $request = $.ajax(params);
          $request.then(success);
          $request.fail(failure);
          return $request;
        }
      }
    });

    $("#activeStatusKey").select2({
      tags: true,
      placeholder: "ทั้งหมด",
      allowClear: true
    });
    //const user = await this.$root.getUser();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#plantTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Plant/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.keyword,
                ActiveStatus: $("#activeStatusKey").val()
              })
            );
          }
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
      <'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_"
        },

        // Order settings
        order: [[9, "desc"]],
        columns: [
          {
            data: null,
            className: "details-control",
            defaultContent: "",
            orderable: false
          },
          { data: "plantId", className: "text-center" },
          { data: "plantDesc", className: "text-center" },
          { data: "address", className: "text-center" },
          { data: "email", className: "text-center" },
          { data: "tel", className: "text-center" },
          { data: "contact", className: "text-center" },
          { data: "latitude", className: "text-center" },
          { data: "longitude", className: "text-center" },
          // { data: "img", className: "text-center" },
          {
            data: "productsList",
            className: "text-center"
          },
          {
            data: "inActiveStatus",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actionsStatus"></div>';
            }
          },
          {
            data: "plantId",
            className: "text-center",
            width: "13%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            }
          }
        ]
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actionsStatus").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditStatusButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_PLANT"
            ]);
            if (data.inActiveStatus == false)
              new StatusActionsTrue({ data: { data }, parent: self }).$mount(
                el
              );
            else if (data.inActiveStatus == true)
              new StatusActionsFalse({ data: { data }, parent: self }).$mount(
                el
              );
          }
        });
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MANAGE_PLANT"
            ]);
            // data.showDeleteButton = self.$root.canShow([
            //   "MANAGE_MASTER",
            //   "MANAGE_PLANT"
            // ]);
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
    //table.trigger("draw.dt"); //call ajax delete this row
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// App/Components/Master/Plant/PlantList.vue